import { graphql, HttpResponse } from 'msw';
import {
  FanReactionType,
  Prefecture,
  type GetPerformanceChannelContentsQuery,
} from '@/__generated__/graphql';

export const getPerformanceChannelContents = graphql.query<GetPerformanceChannelContentsQuery>(
  'GetPerformanceChannelContents',
  () => {
    const isRegistered = true;

    const edges = Array.from({ length: 4 }).map((_, index) => {
      const isArtistPost = index % 2 === 0;

      const parentPatterns = [
        {
          __typename: 'ArtistPost' as const,
          ulid: `ulid-parent-normal`,
          body: '今日はありがとう！今日はありがとう！今日はありがとう！今日はありがとう！今日はありがとう！今日はありがとう！今日はありがとう！',
          channelID: '0ebffe0d-ec5e-4f0c-86dd-01c7b8bccc54',
          isSpoiler: false,
          isMasked: false,
          artistOfficial: {
            __typename: 'ArtistOfficial' as const,
            id: 'artist-parent-normal',
            iconImage: null,
          },
        },
        {
          __typename: 'FanPost' as const,
          ulid: `ulid-parent-spoiler`,
          body: '親投稿（ネタバレ）',
          channelID: '0ebffe0d-ec5e-4f0c-86dd-01c7b8bccc54',
          isSpoiler: true,
          isMasked: false,
          fan: {
            __typename: 'Fan' as const,
            id: 'fan-parent-spoiler',
            iconImage: null,
          },
        },
        {
          __typename: 'ArtistPost' as const,
          ulid: `ulid-parent-masked`,
          body: '親投稿（マスク中）',
          channelID: '0ebffe0d-ec5e-4f0c-86dd-01c7b8bccc54',
          isSpoiler: true,
          isMasked: true,
          artistOfficial: {
            __typename: 'ArtistOfficial' as const,
            id: 'artist-parent-masked',
            iconImage: null,
          },
        },
        {
          __typename: 'FanPost' as const,
          ulid: `ulid-parent-deleted`,
          body: null,
          channelID: '0ebffe0d-ec5e-4f0c-86dd-01c7b8bccc54',
          isSpoiler: false,
          isMasked: false,
          fan: {
            __typename: 'Fan' as const,
            id: 'fan-parent-deleted',
            iconImage: null,
          },
        },
      ];

      const parent = parentPatterns[index % parentPatterns.length];

      return {
        __typename: 'ChannelContentEdge' as const,
        cursor: `cursor-${index}`,
        node: isArtistPost
          ? {
              __typename: 'ArtistPost' as const,
              ulid: `ulid-${index}`,
              body: `アーティスト投稿モック ${index + 1}`,
              channelID: '0ebffe0d-ec5e-4f0c-86dd-01c7b8bccc54',
              isSpoiler: false,
              isMasked: false,
              createdAt: new Date().toISOString(),
              updatedAt: new Date().toISOString(),
              images: [],
              artistOfficial: {
                __typename: 'ArtistOfficial' as const,
                id: `artist-${index}`,
                name: `オフィシャル ${index + 1}`,
                iconImage: null,
              },
              reactions: {
                __typename: 'ArtistPostReactions' as const,
                reactionCounts: [
                  { __typename: 'FanReactionCount' as const, type: FanReactionType.Like, count: 1 },
                ],
                myReactions: isRegistered ? [] : null,
                artistReactions: [],
              },
              parentContent: parent,
            }
          : {
              __typename: 'FanPost' as const,
              ulid: `ulid-${index}`,
              body: `ファン投稿モック ${index + 1}`,
              channelID: '0ebffe0d-ec5e-4f0c-86dd-01c7b8bccc54',
              isSpoiler: false,
              isMasked: false,
              createdAt: new Date().toISOString(),
              updatedAt: new Date().toISOString(),
              fan: {
                __typename: 'Fan' as const,
                id: `fan-${index}`,
                name: `ファン ${index + 1}`,
                iconImage: null,
              },
              reactions: {
                __typename: 'FanPostReactions' as const,
                reactionCounts: [
                  { __typename: 'FanReactionCount' as const, type: FanReactionType.Like, count: 1 },
                ],
                myReactions: isRegistered ? [] : null,
                artistReactions: [],
              },
              superMessageInfo: null,
              parentContent: parent,
            },
      };
    });

    return HttpResponse.json({
      data: {
        __typename: 'Query' as const,
        performanceChannel: {
          __typename: 'PerformanceChannel' as const,
          id: '0ebffe0d-ec5e-4f0c-86dd-01c7b8bccc54',
          artistOfficialsWhoTookAction: [],
          performance: {
            __typename: 'Performance' as const,
            id: 'ccacb2c4-7a59-4e4e-8f73-e67c24ff9a17',
            slug: 'eventtest202509-4',
            name: 'モック公演名',
            venueName: 'モック会場',
            venuePrefecture: Prefecture.Aichi,
            performanceDate: new Date().toISOString(),
          },
          contents: {
            __typename: 'ChannelContentConnection' as const,
            edges,
            pageInfo: {
              __typename: 'PageInfo' as const,
              startCursor: edges[0]?.cursor,
              endCursor: edges[edges.length - 1]?.cursor,
              hasPreviousPage: false,
              hasNextPage: false,
            },
          },
          permission: isRegistered
            ? { __typename: 'ChannelPermission' as const, actionable: true }
            : undefined,
          artist: {
            __typename: 'Artist' as const,
            id: '24aa1891-704e-424d-a838-9866298883e4',
            name: 'テスト用アーティスト',
            color: '#E5136C',
          },
        },
      },
    });
  },
);
